// @flow

import React from 'react'
import { HashLink as Link } from 'react-router-hash-link'
import { translate } from '../../helpers/global'

type Props = {
  globalGetLanguages: string,
  dropdownId?: string
}

const DropdownUniMobile = ({ globalGetLanguages, dropdownId = "uni-drop" }: Props) => {
  // Define content for each section (simplified for mobile)
  const contentSections = {
    solutions: [
      { to: '/admissions', text: 'Admissions' },
      { to: '/career-center', text: 'Career Center' },
    ]
  }

  return (
    <div id={dropdownId} className="dropdown-for hide">
      <div>
        <a href="#" className="a-for">
          <span>Solutions & Use Cases</span>
          <i className="fas fa-angle-down" />
        </a>
        <div style={{display: 'none'}}>
          {contentSections.solutions.map((link, index) => (
            <Link key={index} to={link.to}>{link.text} <i className="fas fa-arrow-right"></i></Link>
          ))}
        </div>
      </div>
      <hr/>
    </div>
  )
}

export default DropdownUniMobile